import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * Modale de confirmation réutilisable — remplace window.confirm().
 *
 * Props :
 *   show       {boolean}  — afficher/masquer la modale
 *   title      {string}   — titre de la modale
 *   message    {string}   — texte de confirmation
 *   onConfirm  {function} — appelé si l'utilisateur confirme
 *   onCancel   {function} — appelé si l'utilisateur annule
 *   confirmLabel {string} — libellé du bouton de confirmation (défaut : "Confirmer")
 *   confirmVariant {string} — variante Bootstrap du bouton (défaut : "danger")
 */
const ConfirmModal = ({
  show,
  title = 'Confirmation',
  message = 'Êtes-vous sûr ?',
  onConfirm,
  onCancel,
  confirmLabel = 'Confirmer',
  confirmVariant = 'danger'
}) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Annuler
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
